import Carousel from '../carousel.js'

// Recruit
export default class recruit {
  constructor() {
    this.init()
  }
  init() {
    this.setSlider()
  }

  setSlider() {
    this.slider = new Carousel('people')
  }
}
